let count = 0;

const observer = !window.ResizeObserver
  ? null
  : new ResizeObserver(entries => {
      entries.forEach(({ target, borderBoxSize }) => {
        const content = target.closest('.accordion-widget-content');

        if (!content || !target.classList.contains('accordion-widget-content-inner')) {
          return;
        }

        // Older browsers don't support borderBoxSize,
        // so we use fallback to recalculating the height
        const height = borderBoxSize?.[0]
          ? Math.ceil(borderBoxSize[0].blockSize)
          : Math.ceil(target.getBoundingClientRect().height);

        content.style.setProperty('--accordion-content-height', `${height}px`);

        // Change transition duration for tall accordions
        content.classList.toggle('tall-accordion', height >= 220);
      });
    });

document.querySelectorAll('.accordion-widget').forEach(item => {
  const button = item.querySelector('.accordion-widget-title');
  const content = item.querySelector('.accordion-widget-content');
  if (!button || !content) return;

  // Set accessibility attributes
  count++;

  const questionId = `accordion-widget-title-${count}`;
  const contentId = `accordion-widget-content-${count}`;

  button.id = questionId;
  button.setAttribute('aria-expanded', item.classList.contains('expanded'));
  button.setAttribute('aria-controls', contentId);

  content.id = contentId;
  button.setAttribute('aria-labelledby', questionId);

  // const group = item.closest('.faq-group') ?? item.parentElement;

  button.addEventListener('click', () => {
    toggle(item, !item.classList.contains('expanded'));
    // if (item.classList.contains('expanded')) {
    //   // Collapse FAQ item
    //   toggle(item, false);
    // } else {
    //   // Expand FAQ item

    //   // Only allow one question per group to be expanded
    //   // at a time. This can be overwritten with a global variable
    //   if (group && !window.allowMultipleExpandedFaqQuestions) {
    //     group.querySelectorAll('.accordion-widget').forEach(el => {
    //       if (el !== item) toggle(el, false);
    //     });
    //   }

    //   toggle(item, true);
    // }
  });

  // Watch for size changes to the inner content.
  // This is used to allow animating the accordions
  if (observer) {
    const contentInner = content.querySelector('.accordion-widget-content-inner');
    if (contentInner) observer.observe(contentInner);
  } else {
    // Fallback to no animation if browser doesn't support ResizeObserver
    item.classList.add('no-animation');
  }
});

function toggle(item, isOpen) {
  if (
    !item?.classList?.contains('accordion-widget') ||
    (isOpen && item.classList.contains('expanded')) ||
    (!isOpen && !item.classList.contains('expanded'))
  ) {
    return;
  }

  const button = item.querySelector('.accordion-widget-title');
  const content = item.querySelector('.accordion-widget-content');

  if (isOpen) {
    item.classList.add('expanded');
    button?.setAttribute('aria-expanded', true);
    content?.setAttribute('aria-hidden', false);
  } else {
    item.classList.remove('expanded');
    button?.setAttribute('aria-expanded', false);
    content?.setAttribute('aria-hidden', true);
  }
}
